import React, { useState } from 'react';
import { getRandomSeat } from '../utils/seatAssignment';
import { saveSeatAssignment } from '../utils/db';
import { SeatConfig, SeatAssignment } from '../types';

interface SeatLotteryFormProps {
  config: SeatConfig;
  onLotteryComplete: (assignment: SeatAssignment) => void;
}

const SeatLotteryForm: React.FC<SeatLotteryFormProps> = ({ config, onLotteryComplete }) => {
  const [name, setName] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!name.trim()) {
      setError('名前を入力してください');
      return;
    }
    
    setError(null);
    setIsSubmitting(true);
    
    try {
      // ランダムな席番号を取得
      const seatNumber = await getRandomSeat(config);
      
      // DBに保存
      const assignment = await saveSeatAssignment({ name, seatNumber });
      
      // 親コンポーネントに通知
      onLotteryComplete(assignment);
    } catch (err) {
      console.error('席抽選に失敗しました:', err);
      setError(err instanceof Error ? err.message : '席抽選に失敗しました。もう一度お試しください。');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="seat-lottery-form">
      <h2>席抽選</h2>
      <p>お名前を入力して、席を抽選しましょう！</p>
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">お名前</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={isSubmitting}
            placeholder="例: 山田 太郎"
            required
          />
        </div>
        
        {error && <div className="error-message">{error}</div>}
        
        <button 
          type="submit" 
          disabled={isSubmitting}
          className="lottery-button"
        >
          {isSubmitting ? '抽選中...' : '席を抽選する'}
        </button>
      </form>
    </div>
  );
};

export default SeatLotteryForm; 